const formatPrice = (price, currency, digits = 0) => {
  if (!currency) return null;
  return new Intl.NumberFormat(currency.code, { style: 'currency', currency: currency.symbol, maximumFractionDigits: digits }).format(price);
};

export default formatPrice;